import { z } from 'zod';
import { fundingTypeValues } from '@/entities/settlementstatisticsconverter/lib/funding-type';
import { recurringTypeValues } from '@/entities/settlementstatisticsconverter/lib/recurring-type';

/**
 * 歳出コード振り結果 訂正フォームのバリデーションスキーマ
 */
export const expenditureEditSchema = z.object({
  /** 決算統計目的（CascaderFieldのコードパス） */
  settlement_purpose_code_path: z.array(z.string()).min(1),
  /** 決算統計性質（CascaderFieldのコードパス） */
  settlement_nature_code_path: z.array(z.string()).min(1),
  /** 臨時経常区分 */
  recurring_type_value: z.enum(recurringTypeValues),
  /** 単独補助区分 */
  funding_type_value: z.enum(fundingTypeValues),
});

export type ExpenditureEditFormValues = z.infer<typeof expenditureEditSchema>;
